import {Badge} from "@/components/ui/badge";
import type {PropertyAmenity} from "@/src/modules/amenities/types";
import type {AmenityRestrictionCheckSource} from "@/src/modules/households/lib/household-amenity-restriction";
import {cn} from "@/lib/utils";

import {isFacilityAmenityTypeRestricted} from "../lib/resident-amenity-restriction-copy";
import {getResidentHomeAmenityTypeMeta} from "../lib/resident-home-amenity-type";

type ResidentHomeAmenitiesPreviewRowProps = {
  amenity: PropertyAmenity;
  household?: AmenityRestrictionCheckSource | null;
  className?: string;
};

export function ResidentHomeAmenitiesPreviewRow({
  amenity,
  household,
  className,
}: ResidentHomeAmenitiesPreviewRowProps) {
  const {label, icon: Icon} = getResidentHomeAmenityTypeMeta(amenity.amenity_type);
  const name = amenity.name?.trim() || "—";
  const isRestricted = isFacilityAmenityTypeRestricted(household, amenity.amenity_type);

  return (
    <div
      className={cn(
        "flex w-full items-center justify-between gap-3 rounded-md border px-3 py-2",
        isRestricted && "border-border/60 bg-muted/40 opacity-80",
        className,
      )}
    >
      <p
        className={cn(
          "min-w-0 truncate text-sm font-medium",
          isRestricted ? "text-muted-foreground" : "text-foreground",
        )}
      >
        {name}
      </p>
      {isRestricted ? (
        <Badge variant="destructive" className="shrink-0 font-normal">
          Restricted
        </Badge>
      ) : (
        <Badge variant="outline" className="shrink-0 gap-1 font-normal">
          <Icon className="size-3.5" aria-hidden />
          {label}
        </Badge>
      )}
    </div>
  );
}
